/* Willamette & Fir — product page & size assistant */
(function () {
  'use strict';
  var WF = window.WF; if (!WF) return;
  var $ = WF.$, $$ = WF.$$, money = WF.money;
  var el = $('[data-wf-pdp]'); if (!el) return;
  var data; try { data = JSON.parse($('[data-wf-product-json]', el).textContent); } catch (e) { return; }
  var product = data.product, form = $('[data-wf-product-form]', el), idInput = $('input[name="id"]', form);
  var current = product.variants.filter(function (v) { return v.id === data.selected; })[0] || product.variants[0];
  var optSets = $$('[data-wf-option]', el);
  var sizeSet = optSets.filter(function (fs) { return fs.hasAttribute('data-wf-size'); })[0];
  var isDesk = function () { return window.matchMedia('(min-width:990px)').matches; };

  function selected() { return optSets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
  function findVariant(sel) { return product.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0]; }
  function markAvailability() {
    var sel = selected();
    optSets.forEach(function (fs, i) {
      $$('input', fs).forEach(function (inp) {
        var t = sel.slice(); t[i] = inp.value;
        var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return t[k] == null || o === t[k]; }); });
        inp.closest('label').classList.toggle('is-unavailable', !ok);
      });
      var lab = $('[data-wf-opt-value]', fs); if (lab) lab.textContent = sel[i] || '';
    });
  }

  /* gallery */
  var track = $('[data-wf-gallery-track]', el), count = $('[data-wf-gallery-count]', el), thumbs = $$('[data-wf-thumb]', el);
  function slides() { return track ? $$('.wf-gallery__slide', track) : []; }
  function goToMedia(id) {
    var list = slides(), s = -1;
    list.forEach(function (x, k) { if (s < 0 && x.getAttribute('data-media-id') == id) s = k; });
    if (s < 0) return;
    if (isDesk()) { if (s > 0) list[s].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    else track.scrollTo({ left: s * track.clientWidth, behavior: 'smooth' });
  }
  if (track) {
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (count) count.textContent = (n + 1) + ' / ' + slides().length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === n); });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); });
  }

  function update() {
    var v = findVariant(selected()); if (!v) return;
    current = v; idInput.value = v.id;
    var now = $('[data-wf-price]', el), was = $('[data-wf-compare]', el), save = $('[data-wf-save]', el);
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    now.textContent = money(v.price); now.classList.toggle('wf-price__now--sale', !!sale);
    was.textContent = sale ? money(v.compare_at_price) : ''; was.hidden = !sale;
    if (save) { save.hidden = !sale; if (sale) save.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; }
    var btn = $('[data-wf-atc]', el); btn.disabled = !v.available;
    $('[data-wf-atc-label]', el).textContent = v.available ? 'Add to bag' : 'Sold out';
    markAvailability();
    if (v.featured_media) goToMedia(v.featured_media.id);
    if (history.replaceState) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {} }
  }
  optSets.forEach(function (fs) { fs.addEventListener('change', function () { var m = $('[data-wf-msg]', el); if (m) m.textContent = ''; update(); }); });
  markAvailability();

  /* quantity */
  var qty = $('[data-wf-qty]', el);
  $$('[data-wf-qty-step]', el).forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (Number(qty.value) || 1) + Number(b.getAttribute('data-wf-qty-step'))); }); });

  /* add to bag */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = $('[data-wf-msg]', el); msg.textContent = '';
    if (sizeSet && !$('input:checked', sizeSet)) { msg.textContent = 'Please choose a size. Not sure? Tap “Find my size”.'; sizeSet.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    var btn = $('[data-wf-atc]', el), label = $('[data-wf-atc-label]', el);
    btn.disabled = true; label.textContent = 'Adding…';
    WF.addToCart([{ id: Number(idInput.value), quantity: Number(qty ? qty.value : 1) || 1 }])
      .catch(function (err) { msg.textContent = err.message; })
      .then(function () { btn.disabled = !current.available; label.textContent = current.available ? 'Add to bag' : 'Sold out'; });
  });

  /* delivery window: 1-2 business days processing + 3-4 shipping */
  var eta = $('[data-wf-eta]', el);
  if (eta && current.available) {
    var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
    var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    eta.innerHTML = 'In stock. Order today, arrives <b>' + f(addBiz(new Date(), 4)) + ' – ' + f(addBiz(new Date(), 6)) + '</b>';
  }

  /* ---------- size assistant ---------- */
  var sa = $('#wf-size-assistant'); if (!sa) return;
  var gender = sa.getAttribute('data-gender'), cat = sa.getAttribute('data-category');
  var steps = $$('.wf-sa__step', sa), bars = $$('.wf-sa__progress i', sa), stepIdx = 0, answers = {}, unit = 'us', resultValue = null;
  var LET = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  function go(n) { stepIdx = n; steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); }); bars.forEach(function (b, k) { b.classList.toggle('is-done', k <= n); }); var p = $('.wf-modal__panel', sa); if (p) p.scrollTop = 0; }
  $$('[data-wf-sa-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(0); WF.open(sa); }); });
  $$('.wf-sa__units button', sa).forEach(function (b) {
    b.addEventListener('click', function () {
      unit = b.getAttribute('data-unit');
      $$('.wf-sa__units button', sa).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      $$('[data-unit-us]', sa).forEach(function (x) { x.hidden = unit !== 'us'; });
      $$('[data-unit-metric]', sa).forEach(function (x) { x.hidden = unit !== 'metric'; });
    });
  });
  $$('.wf-sa__choices', sa).forEach(function (g) {
    $$('.wf-sa__choice', g).forEach(function (c) {
      c.addEventListener('click', function () {
        $$('.wf-sa__choice', g).forEach(function (x) { x.classList.toggle('is-selected', x === c); });
        answers[g.getAttribute('data-q')] = Number(c.getAttribute('data-v'));
        setTimeout(next, 220);
      });
    });
  });
  function readBody() {
    var err = $('[data-wf-sa-err]', sa); err.textContent = '';
    if (cat === 'shoes') { var s = Number($('[data-wf-sa-shoe]', sa).value); if (!s) { err.textContent = 'Please choose your usual size.'; return false; } answers.shoe = s; return true; }
    var h, w;
    if (unit === 'us') { h = Number($('[data-wf-sa-ft]', sa).value) * 12 + (Number($('[data-wf-sa-in]', sa).value) || 0); w = Number($('[data-wf-sa-lb]', sa).value); }
    else { h = Number($('[data-wf-sa-cm]', sa).value) / 2.54; w = Number($('[data-wf-sa-kg]', sa).value) * 2.2046; }
    if (!(h > 54 && h < 90) || !(w > 70 && w < 450)) { err.textContent = 'Please enter your height and weight.'; return false; }
    answers.h = h; answers.w = w; return true;
  }
  function next() { if (stepIdx === 0 && !readBody()) return; if (stepIdx < steps.length - 2) go(stepIdx + 1); else { compute(); go(steps.length - 1); } }
  $$('[data-wf-sa-next]', sa).forEach(function (b) { b.addEventListener('click', next); });
  $$('[data-wf-sa-back]', sa).forEach(function (b) { b.addEventListener('click', function () { go(Math.max(0, stepIdx === steps.length - 1 ? 0 : stepIdx - 1)); }); });

  var values = sizeSet ? $$('input', sizeSet).map(function (i) { return i.value; }) : [];
  function norm(v) {
    var s = String(v).toUpperCase().replace(/\s+/g, '').replace('EXTRA', 'X');
    var map = { 'X-SMALL': 'XS', XSMALL: 'XS', SMALL: 'S', MEDIUM: 'M', LARGE: 'L', 'X-LARGE': 'XL', XLARGE: 'XL', 'XX-LARGE': 'XXL', XXLARGE: 'XXL', '2XL': 'XXL', XXXL: '3XL', '2XS': 'XXS' };
    return map[s] || s;
  }
  function num(v) { var m = String(v).match(/(\d+(?:[.,]5)?)/); return m ? Number(m[1].replace(',', '.')) : NaN; }
  var womenNum = { XXS: 0, XS: 2, S: 5, M: 9, L: 13, XL: 16, XXL: 18, '3XL': 20 };
  var womenWaist = { XXS: 24, XS: 25, S: 27, M: 29, L: 31, XL: 33, XXL: 35, '3XL': 37 };
  var menWaist = { XXS: 27, XS: 28, S: 30, M: 32, L: 34, XL: 36, XXL: 38, '3XL': 40 };
  var menChest = { XXS: 34, XS: 36, S: 38, M: 40, L: 42, XL: 44, XXL: 46, '3XL': 48 };
  function match(letter, shoe) {
    if (!values.length) return null;
    var best = null, bd = 99;
    if (shoe != null) {
      values.forEach(function (v) { var n = num(v); if (isNaN(n)) return; var us = n > 30 ? (gender === 'men' ? n - 33 : n - 31) : n; var d = Math.abs(us - shoe); if (d < bd) { bd = d; best = v; } });
      return best;
    }
    var exact = values.filter(function (v) { return norm(v) === letter; })[0]; if (exact) return exact;
    var nums = values.filter(function (v) { return !isNaN(num(v)); }); if (!nums.length) return null;
    var first = num(nums[0]), target;
    if (gender === 'men') target = (cat !== 'bottoms' && first >= 34) ? menChest[letter] : menWaist[letter];
    else target = (cat === 'bottoms' && first >= 22) ? womenWaist[letter] : womenNum[letter];
    nums.forEach(function (v) { var d = Math.abs(num(v) - target); if (d < bd) { bd = d; best = v; } });
    return best;
  }
  function compute() {
    var out = $('[data-wf-sa-size]', sa), why = $('[data-wf-sa-why]', sa), label, notes = [];
    if (cat === 'shoes') {
      var s = Math.round((answers.shoe + (answers.width || 0) + (answers.socks || 0)) * 2) / 2;
      label = 'US ' + s; resultValue = match(null, s);
      if (answers.width > 0) notes.push('half a size up for a wider foot');
      if (answers.socks > 0) notes.push('room for thick wool socks');
      notes = ['Based on your usual size' + (notes.length ? ', plus ' + notes.join(' and ') : '') + '. Our footwear follows standard US sizing.'];
    } else {
      var w = answers.w, h = answers.h, b;
      if (gender === 'men') b = w <= 135 ? 1 : w <= 155 ? 2 : w <= 178 ? 3 : w <= 202 ? 4 : w <= 228 ? 5 : w <= 255 ? 6 : 7;
      else b = w <= 110 ? 1 : w <= 126 ? 2 : w <= 145 ? 3 : w <= 166 ? 4 : w <= 190 ? 5 : w <= 215 ? 6 : 7;
      if (h > (gender === 'men' ? 74 : 69)) { b += 0.35; notes.push('a little extra length for your height'); } else if (h < (gender === 'men' ? 67 : 62)) b -= 0.25;
      b += (answers.build || 0) + (answers.fit || 0) + (answers.extra || 0);
      if (cat === 'dress' && answers.build > 0) b += 0.25;
      if (cat === 'outerwear' && answers.extra > 0) notes.push('room to layer over a heavy knit');
      if (answers.fit > 0) notes.push('your relaxed fit preference'); else if (answers.fit < 0) notes.push('your closer fit preference');
      label = LET[Math.max(0, Math.min(7, Math.round(b)))]; resultValue = match(label, null);
      notes = ['Based on your height, weight and build' + (notes.length ? ', plus ' + notes.join(' and ') : '') + '.'];
    }
    out.textContent = resultValue || label;
    why.textContent = notes.join(' ') + (resultValue ? '' : ' This size isn’t listed for this item. Email us and we’ll help you choose.');
    var add = $('[data-wf-sa-add]', sa), sel = $('[data-wf-sa-select]', sa);
    add.hidden = !resultValue; sel.hidden = !resultValue;
    if (resultValue) $('span', add).textContent = 'Select ' + resultValue + ' & add to bag';
  }
  function pick() { var inp = $$('input', sizeSet).filter(function (i) { return i.value === resultValue; })[0]; if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); } }
  var add = $('[data-wf-sa-add]', sa);
  if (add) add.addEventListener('click', function () { if (!resultValue || !sizeSet) return; pick(); WF.close(sa); if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
  var only = $('[data-wf-sa-select]', sa);
  if (only) only.addEventListener('click', function () { if (!resultValue || !sizeSet) return; pick(); WF.close(sa); });
})();